export const SearchCriteriaEnum = {
    Unit: { typeId: 60528 },
    Contact: { typeId: 60526 },
    Lead: { typeId: 60529 },
    Property: { typeId: 60527 }
};
